export const presentationStatuses = {
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  UNDRAFTED: "text-purple-600 bg-purple-50 ring-purple-500/10",
  READY_FOR_DRAFTING: "text-blue-600 bg-blue-50 ring-blue-500/10",
  DRAFTING: "text-blue-600 bg-blue-50 ring-blue-500/10",
  REVIEW: "text-purple-600 bg-purple-50 ring-purple-500/10",
  APPROVED: "text-green-700 bg-green-50 ring-green-600/20",
  CANCELLED: "text-gray-700 bg-gray-50 ring-gray-600/10",
}

export const quoteStatuses = {
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  NOT_SUBMITTED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  PENDING: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ACCEPTED: "text-green-700 bg-green-50 ring-green-600/20",
  REJECTED: "text-red-700 bg-red-50 ring-red-600/10",
  CANCELLED: "text-gray-700 bg-gray-50 ring-gray-600/10",
}

export const quoteExpiredStatuses = {
  VALID: "text-green-700 bg-green-50 ring-green-600/20",
  EXPIRED: "text-red-700 bg-red-50 ring-red-600/10",
  NEARING_EXPIRY: "text-pink-700 bg-pink-50 ring-pink-700/10",
}

export const automationStatuses = {
  NOT_STARTED: "text-gray-400 bg-gray-400/10",
  SUCCEEDED: "text-green-400 bg-green-400/10",
  FAILED: "text-rose-400 bg-rose-400/10",
  PARTIAL_SUCCESS: "text-orange-400 bg-orange-400/10",
  PROCESSING: "text-indigo-400 bg-indigo-400/10",
  CANCELLED: "text-gray-400 bg-gray-400/10",
}

export const gridConnectionStatuses = {
  OFF_PLATFORM: "text-gray-600 bg-gray-50 ring-gray-500/10",
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  CANCELLED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  REVISION_ONGOING: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  REVISION_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_PREPARING: "text-purple-600 bg-purple-50 ring-purple-500/10",
  ENEDIS_F2_CONFIRMED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_F2_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_URBAN_SOLAR_CONFIRMED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_URBAN_SOLAR_SUBSCRIBED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_URBAN_SOLAR_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_MISE_SERVICE_REQUESTED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_MISE_SERVICE_VISIT_SCHEDULED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_PDR_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_PDR_ACCEPTED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_F2_REJECTED: "text-red-700 bg-red-50 ring-red-600/10",
  ENEDIS_URBAN_SOLAR_REJECTED: "text-red-700 bg-red-50 ring-red-600/10",
  ENEDIS_URBAN_SOLAR_APPROVED: "text-green-700 bg-green-50 ring-green-600/20",
  PREPARING: "text-purple-600 bg-purple-50 ring-purple-500/10",
  CONFIRMED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  DIRECT_CONNECTION_AGREEMENT_PREPARED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  DIRECT_CONNECTION_AGREEMENT_SIGNED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_QUOTE_TRANSFERRED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_QUOTE_SIGNED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_QUOTE_DOWNPAYMENT:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_SCHEDULED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_COMPLETE: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_CONSTRUCTION_QUOTE_FINALPAYMENT:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  GRID_CONNECTION_CONTRACT_PREPARED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  GRID_CONNECTION_CONTRACT_SIGNED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENEDIS_MISE_SERVICE_VISIT_COMPLETE:
    "text-green-700 bg-green-50 ring-green-600/20",
}

export const mayorFormStatuses = {
  OFF_PLATFORM: "text-gray-600 bg-gray-50 ring-gray-500/10",
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  CANCELLED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  REVISION_ONGOING: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  REVISION_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  CONTEST_ONGOING: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  PREPARING: "text-purple-600 bg-purple-50 ring-purple-500/10",
  SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  CONFIRMED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ACCEPTED: "text-green-700 bg-green-50 ring-green-600/20",
  REJECTED: "text-red-700 bg-red-50 ring-red-600/10",
  DAACT_SENT: "text-green-700 bg-green-50 ring-green-600/20",
  DAACT_CONFIRMED: "text-green-700 bg-green-50 ring-green-600/20",
  DAACT_COMPLETE: "text-green-700 bg-green-50 ring-green-600/20",
}

export const consuelStatuses = {
  OFF_PLATFORM: "text-gray-600 bg-gray-50 ring-gray-500/10",
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  CANCELLED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  REVISION_ONGOING: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  REVISION_SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  PREPARING: "text-purple-600 bg-purple-50 ring-purple-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_REQUESTED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_RECEIVED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_SIGNED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_SCHEDULED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_COMPLETE:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  REJECTED: "text-red-700 bg-red-50 ring-red-600/10",
  APPROVED: "text-green-700 bg-green-50 ring-green-600/20",
}

export const SC144Versions = {
  SC144A_4: "text-blue-600 bg-blue-50 ring-blue-500/10",
  SC144B_4: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  SC144C_4: "text-purple-600 bg-purple-50 ring-purple-500/10",
  SC144C2_1: "text-purple-600 bg-purple-50 ring-purple-500/10",
}

export const origins = {
  ONBOARDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  MATCHED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  PLATFORM: "text-purple-600 bg-purple-50 ring-purple-500/10",
  LAUNCHED: "text-purple-600 bg-purple-50 ring-purple-500/10",
}

export const paymentStatuses = {
  SUCCEEDED: "text-green-700 bg-green-50 ring-green-600/20",
  DELIVERED: "text-green-700 bg-green-50 ring-green-600/20",
  NO_PAYMENT_REQUIRED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ATTEMPTED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  PROCESSING: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
  REQUIRES_CONFIRMATION: "text-red-700 bg-red-50 ring-red-600/10",
  CANCELED: "text-red-700 bg-red-50 ring-red-600/10",
  REQUIRES_ACTION: "text-red-700 bg-red-50 ring-red-600/10",
  REQUIRES_PAYMENT_METHOD: "text-red-700 bg-red-50 ring-red-600/10",
  REQUIRES_CAPTURE: "text-red-700 bg-red-50 ring-red-600/10",
  PAYMENT_FAILED: "text-red-700 bg-red-50 ring-red-600/10",
  PARTIAL_REFUND_FAILED: "text-red-700 bg-red-50 ring-red-600/10",
  REFUND_FAILED: "text-red-700 bg-red-50 ring-red-600/10",
  REFUNDED: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  PARTIAL_REFUNDED: "text-indigo-700 bg-indigo-50 ring-indigo-500/10",
  PARTIAL_REFUND_IN_PROGRESS: "text-indigo-700 bg-indigo-50 ring-indigo-500/10",
  REFUND_IN_PROGRESS: "text-indigo-700 bg-indigo-50 ring-indigo-500/10",
  UNATTEMPTED: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
}

export const paymentTypes = {
  ORDER: "text-green-700 bg-green-50 ring-green-600/20",
  TECHNICAL_VISIT: "text-gray-600 bg-gray-50 ring-gray-500/10",
  FINALPAYMENT: "text-gray-600 bg-gray-50 ring-gray-500/10",
  DOWNPAYMENT: "text-green-700 bg-green-50 ring-green-600/20",
  INVOICE: "text-indigo-700 bg-indigo-50 ring-indigo-600/20",
  GENERAL_CONTRACT: "text-indigo-700 bg-indigo-50 ring-indigo-600/20",
}

export const invoiceStatuses = {
  draft: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  open: "text-blue-600 bg-blue-50 ring-blue-500/10",
  void: "text-gray-600 bg-gray-50 ring-gray-500/10",
  paid: "text-green-700 bg-green-50 ring-green-600/20",
  uncollectible: "text-red-700 bg-red-50 ring-red-600/10",
}

export const orderStatuses = {
  COMPLETED: "text-green-700 bg-green-50 ring-green-600/20",
  IN_TRANSIT: "text-gray-600 bg-gray-50 ring-gray-500/10",
  PROCESSING: "text-gray-600 bg-gray-50 ring-gray-500/10",
  DELIVERED: "text-green-700 bg-green-50 ring-green-600/20",
  PICKUP_AVAILABLE: "text-blue-600 bg-blue-50 ring-blue-500/10",
  AWAITING_CONFIRMATION: "text-blue-600 bg-blue-50 ring-blue-500/10",
  PROBLEM: "text-red-700 bg-red-50 ring-red-600/10",
  CANCELLED: "text-gray-700 bg-gray-50 ring-gray-600/10",
  PAYMENT_DUE: "text-red-700 bg-red-50 ring-red-600/10",
  RETURNED: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
}

export const resaleAgreementMyLightStatuses = {
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  ACTIVATED: "text-green-700 bg-green-50 ring-green-600/20",
  UNDRAFTED: "text-red-700 bg-red-50 ring-red-600/10",
  VOIDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  SIGNED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  CANCELLED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  VALIDATED: "text-blue-600 bg-blue-50 ring-blue-500/10",
}

export const resaleAgreementEDFOAStatuses = {
  COMPLETE: "text-green-700 bg-green-50 ring-green-600/20",
  NOT_ADDED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  PREPARING: "text-gray-600 bg-gray-50 ring-gray-500/10",
  NOTIFIED: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_REQUESTED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_RECEIVED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_QUOTE_SIGNED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_SCHEDULED:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  ELECTRICAL_SAFETY_INSPECTION_COMPLETE:
    "text-blue-600 bg-blue-50 ring-blue-500/10",
  SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  CONFIRMED: "text-blue-600 bg-blue-50 ring-blue-500/10",
}

export const resaleAgreementTypes = {
  VIRTUAL_BATTERY: "text-indigo-700 bg-indigo-50 ring-indigo-600/20",
  FEED_IN_TARIFF: "text-gray-600 bg-gray-50 ring-gray-500/10",
}

export const contactAttemptStatuses = {
  CANCELLED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  REQUIRES_REATTEMPT: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
  SENT: "text-blue-600 bg-blue-50 ring-blue-500/10",
  NO_RESPONSE: "text-red-700 bg-red-50 ring-red-600/10",
  RESPONDED: "text-green-700 bg-green-50 ring-green-600/20",
  RECEIVED: "text-green-700 bg-green-50 ring-green-600/20",
}

export const contactAttemptFormats = {
  PHONE: "text-gray-400 bg-gray-600/30 ring-gray-700",
  EMAIL: "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
  SOCIAL_DIRECT_MESSAGING:
    "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
  AIRCALL: "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
  ONLINE_CALL: "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
  IN_PERSON: "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
  SMS: "text-indigo-400 bg-indigo-400/10 ring-indigo-400/30",
}

export const calendarEventChipColours = {
  TECHNICAL_VISIT: "bg-purple-300 hover:bg-purple-200",
  SCHEDULED_INSTALLATION: "bg-purple-700 hover:bg-purple-600",
  COMPLETED_INSTALLATION: "bg-purple-700 hover:bg-purple-600",
  EXPECTED_INSTALLATION: "bg-purple-700 hover:bg-purple-600",
  ELECTRICAL_INSPECTION_AGENCY_VISIT: "bg-blue-800 hover:bg-blue-700",
  CONSUEL_REQUIRED_VISIT: "bg-blue-400 hover:bg-blue-300",
  ENEDIS_MISE_VISIT: "bg-green-300 hover:bg-green-200",
  MAYOR_VISIT: "bg-green-700 hover:bg-green-600",
  MAINTENANCE: "bg-green-700 hover:bg-green-600",
  OTHER: "bg-orange-400 hover:bg-orange-400",
}

export const rfqStatuses = {}

export const payerTypes = {
  INSTALLER: "text-green-700 bg-green-50 ring-green-600/20",
  HOUSEHOLD: "text-blue-600 bg-blue-50 ring-blue-500/10",
}

export const payeeTypes = {
  SUPPLIER: "text-blue-700 bg-blue-50 ring-blue-600/20",
  INSTALLER: "text-green-600 bg-green-50 ring-green-500/10",
}

export const installerTags = {
  NEW: "bg-yellow-400",
  LOST: "bg-gray-400",
  SENSITIVE: "bg-orange-400",
  LARGE: "bg-green-400",
  REQUIRES_DAACT: "bg-blue-400",
}

export const ticketTags = {
  URGENT: "bg-purple-500",
  REQUIRES_CHASING: "bg-pink-400",
  ACTIONABLE: "bg-green-400",
  INSTALLER_ACTION_REQUIRED: "bg-red-400",
  USER_ACTION_REQUIRED: "bg-red-400",
}

export const hourSlotTypes = {
  PEAK: "text-green-700 bg-green-50 ring-green-600/20",
  OFF_PEAK: "text-blue-600 bg-blue-50 ring-blue-500/10",
  BASE: "text-purple-600 bg-purple-50 ring-purple-500/10",
}

export const creditStatuses = {
  AVAILABLE: "text-green-700 bg-green-50 ring-green-600/20",
  USED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  CANCELED: "text-gray-600 bg-gray-50 ring-gray-500/10",
  REQUIRES_PAYMENT_ACTION: "text-red-700 bg-red-50 ring-red-600/10",
  REQUIRES_PAYMENT_ACTION_IN_USE:
    "text-orange-700 bg-orange-50 ring-orange-600/10",
  PAYMENT_PROCESSING: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
  PAYMENT_PROCESSING_IN_USE: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
  REFUND_PENDING: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
  REFUNDED: "text-yellow-700 bg-yellow-50 ring-yellow-500/10",
}

export const creditTypes = {
  MAYOR_SMALL_PRODUCER: "text-green-700 bg-green-50 ring-green-600/20",
  MAYOR_LARGE_PRODUCER: "text-green-700 bg-green-50 ring-green-600/20",
  CONSUEL_SMALL_PRODUCER: "text-gray-600 bg-gray-50 ring-gray-500/10",
  CONSUEL_LARGE_PRODUCER: "text-gray-600 bg-gray-50 ring-gray-500/10",
  GRID_CONNECTION_SMALL_PRODUCER: "text-gray-600 bg-gray-50 ring-gray-500/10",
  GRID_CONNECTION_LARGE_PRODUCER: "text-gray-600 bg-gray-50 ring-gray-500/10",
  GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
    "text-gray-600 bg-gray-50 ring-gray-500/10",
  GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA:
    "text-gray-600 bg-gray-50 ring-gray-500/10",
  CRE: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
  PRESENTATION: "text-indigo-600 bg-indigo-50 ring-indigo-500/10",
}

export const deliveryStatuses = {
  PROCESSING: "border-gray-400 bg-gray-200 text-gray-500",
  DISPATCHED: "border-blue-400 bg-blue-200 text-blue-500",
  IN_TRANSIT: "border-indigo-300 bg-indigo-100 text-indigo-500",
  DELIVERED: "border-green-400 bg-green-200 text-green-500",
}

export const enedisSGEQueryLogsStatuses = {
  ONGOING: "text-blue-600 bg-blue-50 ring-blue-500/10",
  ENDED: "text-green-700 bg-green-50 ring-green-600/20",
  IN_PROGRESS: "text-gray-600 bg-gray-50 ring-1 ring-gray-500/10",
  FAILED: "text-red-700 bg-red-50 ring-1 ring-red-600/10",
  SUCCESS: "text-green-700 bg-green-50 ring-1 ring-green-600/20",
}
